<template>
	<b-container>
		<customer-form
			:customer="customer"
			:creating="creating"
			@delete="deleteCustomer"
			@update="updateCustomer"
		/>

		<confirm ref="confirm"></confirm>
	</b-container>
</template>

<script>
import CustomerService from "@/api-services/customer.service";
import CustomerForm from "@/components/customer/customer-form";
import Confirm from "@/components/partials/confirm";

export default {
	name: "CustomerUpdate",

	components: {
		CustomerForm,
		Confirm,
	},

	data() {
		return {
			customer: {
				InvoiceContactId: null,
				InvoiceContact: {},
				Contacts: [],
				Jobs: [],
				Clocks: [],
				ServiceContracts: [],
			},

			editing: {
				id: null,
				index: null,
			},

			creating: false,
		};
	},

	created() {
		this.fetchCustomer();
	},

	methods: {
		fetchCustomer() {
			CustomerService.get(this.$router.currentRoute.params.id)
				.then((response) => {
					this.customer = response.data;
					if (this.customer.InvoiceContact == null)
						this.customer.InvoiceContact = {};
				})
				.catch((error) => {
					console.log("not authorized");
				});
		},

		updateCustomer() {
			CustomerService.update(this.customer.Id, this.customer)
				.then((res) => {})
				.catch((error) => {
					let modal_options = {
						text : "light",
						background : "danger"
					};
					this.$refs.confirm.open("Error", error.response.data, true, modal_options);
				});
		},

		deleteCustomer() {
			this.$refs.confirm
				.open(
					"Delete",
					"Are you sure you want to delete this customer?"
				)
				.then((confirm) => {
					if (confirm) {
						CustomerService.delete(this.customer.Id)
							.then(() => {
								this.$refs.confirm
									.open(
										"Success",
										"Successfully deleted customer",
										true
									)
									.then((confirm) => {
										this.$router.push({
											name: "customers",
										});
									});
							})
							.catch((error) => {
								let modal_options = {
									text : "light",
									background : "danger"
								};

								this.$refs.confirm.open("Error", error.response.data, true, modal_options);
							});
					}
				});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/customer/customer-update.vue